import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'AJOUT_ETAB',
  title: 'Come posso iscrivere le mie altre imprese?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Se hai più di un\'impresa, ne puoi depositare i documenti sulla piattaforma. Basta seguire i seguenti passi:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Clicca in alto a sinistra sul nome della tua impresa e visualizza sul menu che si apre'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_AJOUT_ETAB/IT_AJOUT_ETAB_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Quindi fai clic su «Selezionare un\'azienda»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_AJOUT_ETAB/IT_AJOUT_ETAB_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Quindi inserisci il Codice Fiscale che vuoi aggiungere e clicca su «Continuare»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_AJOUT_ETAB/IT_AJOUT_ETAB_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Se la tua struttura non è presente sulla piattaforma, inserisci tutte le informazioni richieste.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_AJOUT_ETAB/IT_AJOUT_ETAB_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Una volta che le informazioni sono fornite, la vostra richiesta di aggiunta è in fase di elaborazione. Riverete quindi una notifica via e-mail.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_AJOUT_ETAB/IT_AJOUT_ETAB_5.png`
  }]
};
